<template>
  <div>
    <!-- <div>
      <div class="error" v-show="dataFetchError">
        <p>Unable to fetch query data. Please try again.</p>
      </div>
    </div>-->

    <div class="page-head">
      <h1 class="page-title" style="border-bottom: 2px solid #eaeaea;">Query</h1>

      <p>
        <font-awesome-icon icon="exclamation-triangle" />You can respond to any query by clicking on the chat icon. Your account officer will be waiting to hear you out.
      </p>
    </div>

    <div class="page-body">
      <div class="multiple-entry-form">
        <h5>Recent Query Issued To You:</h5>

        <div class="row query-info">
          <div class="col-md-6 left-column">
            <div class="d-flex align-items-center justify-content-between">
              <p class="key">Issued By:</p>
              <p class="value">{{query.issued_by}}</p>
            </div>

            <div class="d-flex align-items-center justify-content-between">
              <p class="key">Date:</p>
              <p class="value">{{complaintCreatedDate}}</p>
            </div>

            <div class="d-flex align-items-center justify-content-between">
              <p class="key">Title:</p>
              <p class="value">{{query.title}}</p>
            </div>

            <div class="d-flex align-items-center justify-content-between">
              <p class="key">Status:</p>
              <p class="value">
                <span class="pending-status" v-show="query.status == 0">Pending</span>
                <span class="issued-status" v-show="query.status == 1">Issued</span>
              </p>
            </div>
          </div>

          <hr />

          <div class="col-md-6 right-column">
            <h4>Query Details:</h4>
            <p>{{query.description}}</p>
            <h4>Query Response(s):</h4>

            <div class="query__list" v-if="!queryLoader">
              <div v-for="query in queryReplies" v-bind:key="query.index">
                <span>By {{query.user.firstname}} {{query.user.lastname}} on {{query.created_at}}</span>
                <p>{{query.comments}}</p>
              </div>
            </div>

            <span
              class="page__err"
              v-if="loadQueryErr"
            >We are unable to load queries at this time, please try again later.</span>

            <div class="query__loader" v-if="queryLoader">
              <PageLoader />
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center bottom-row">
          <div class="chat__container" v-if="chat">
            <textarea placeholder="Write reply here.." v-model="chatMessage"></textarea>
            <span
              class="page__err"
              v-if="loadQueryErr"
            >We are unable to send your respond at this time, please try again later.</span>
            <div>
              <div class="chat__container--send" @click="sendQueryResp" v-if="!btnLoader">Send</div>
              <div class="chat__container--send" v-if="btnLoader">
                <WhiteLoader />
              </div>

              <div class="chat__container--cancel" @click.prevent="chatContainer()">Cancel</div>
            </div>
          </div>
          <div class="chat__btn" @click.prevent="chatContainer()" v-if="!chat">
            <div class="chat__btn--image">
              <img src="./../../../assets/style/images/speech-bubble.svg" />
            </div>
            <div class="chat__btn--text">Chat with your account officer</div>
          </div>
        </div>
      </div>
      <!-- column end -->
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import WhiteLoader from "../../partials/white-loader";
import PageLoader from "../../partials/page-loader";

export default {
  name: "view-query",

  components: {
    WhiteLoader,
    PageLoader
  },

  data() {
    return {
      item: "viewQuery",
      hr: "hr",
      uploadedFile: false,
      file: "",
      fileName: "",
      uploadedFileName: "",
      previewImage: "",
      query: {},
      queries: [],
      queriedUser: {},
      loading: false,
      dataFetchError: false,
      chat: false,
      chatMessage: "",
      queryReplies: [],
      queryLoader: true,
      btnLoader: false,
      sendQueryErr: false,
      loadQueryErr: false
    };
  },

  created() {
    this.getQueries();
    this.getAllQueries();
  },

  mounted() {
    document.getElementById("offCanvas").checked = false;
  },

  computed: {
    complaintCreatedDate() {
      if (this.query.created_at) {
        const date = new Date(this.query.created_at);
        return date.toLocaleString().split(", ")[0];
      }
      return "";
    }
  },

  methods: {
    getQueries() {
      const query = this.$store.state.query;
      if (Object.keys(query).length === 0) {
        this.$router.push("/queries");
        return;
      }
      this.queries = [...query];
      this.queries.forEach(query => {
        if (query.id === this.$route.params.id) {
          this.query = query;
        }
      });
    },
    chatContainer() {
      if (this.chat) {
        this.chat = false;
      } else {
        this.chat = true;
      }
    },
    sendQueryResp() {
      this.btnLoader = true;
      this.sendQueryErr = false;
      this.loadQueryErr = false;
      this.$http
        .patch(types.GET_QUERY_API, {
          query_id: this.query.id,
          comments: this.chatMessage
        })
        .then(resp => {
          this.getAllQueries();
          this.chat = false;
          this.btnLoader = false;
          this.sendQueryErr = false;
        })
        .catch(err => {
          this.sendQueryErr = true;
        });
    },
    getAllQueries() {
      this.queryLoader = true;
      this.loadQueryErr = false;
      this.sendQueryErr = false;
      this.$http
        .get(`${types.GET_EMPLOYEE_QUERY_API}/${this.query.id}`)
        .then(resp => {
          this.queryReplies = [...resp.data.data.query_replies];
          this.queryLoader = false;
          this.loadQueryErr = false;
        })
        .catch(err => {
          this.loadQueryErr = true;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  > div {
    padding-top: 10px;
    padding-bottom: 100px;
    padding-left: 3.125vw;
    padding-right: 3.125vw;

    .page-head {
      > p {
        margin-top: 15px;
        svg {
          color: #f3826c;
        }
      }

      > h1 {
        padding-bottom: 5px;
      }

      margin-bottom: 70px;
    }
  }
}

.error {
  margin-top: 10px;
  text-align: center;
  color: red;
  font-size: 0.938vw;
  font-style: italic;
  p {
    margin: 0;
    padding-bottom: 10px;
  }
  p::first-letter {
    text-transform: uppercase;
  }
}

* {
  font-family: Nunito;
}

.left-column {
  border-right: 1px dotted #777;
  padding-right: 40px;

  p {
    margin-bottom: 0;
  }
  > div {
    margin-bottom: 30px;
  }
  .key {
    width: auto;
    font-size: 16px;
    line-height: 1.19;
    color: #000000;
  }
  .value {
    width: auto;
    font-size: 16px;
    font-weight: 200;
    line-height: 1.19;
    color: #000000;
  }
}

.right-column {
  padding-left: 40px;

  h4 {
    font-size: 16px;
    line-height: 1.19;
    color: #000000;
    text-decoration: underline;
    margin-bottom: 10px;
  }

  p {
    margin-top: 10px;
    margin-bottom: 15px;
    font-size: 12px;
    font-weight: 200;
    line-height: 1.56;
    color: #000000;
    margin-bottom: 20px;
  }

  > .query__list {
    > div {
      border-bottom: 1px solid #ccc;
      margin-bottom: 20px;

      > span {
        font-size: 12px;
        font-weight: 200;
        line-height: 1.56;
        color: #5099de;
        margin-bottom: 20px;
      }

      > p {
        margin: 0;
      }
    }
  }

  > .query__loader {
    width: 55px;
    margin: auto;
  }
}

.multiple-entry-form {
  background-color: #fff;
  padding: 18px;
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

  hr {
    display: none;
  }

  > h5 {
    margin-left: 15px;
    margin-bottom: 40px;
    font-size: 18px;
    color: #5099de;
  }

  .bottom-row {
    margin-top: 50px;

    .btn {
      border-color: blue;
      width: 366px;
      padding: 15px;
      border: solid 1px #5099de;
      color: #5099de;
      background-color: #ffffff;
      cursor: pointer;
      a {
        width: auto;
        cursor: pointer;
      }

      img {
        width: 26.7px;
        height: 24px;
        margin-right: 10px;
      }
    }
  }
}

.query-info {
  margin: auto;
  .pending-status {
    padding: 5px;
    color: #fff;
    text-transform: capitalize;
    border-radius: 2px;
    background-color: #f3826c;
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.17;
    letter-spacing: normal;
    margin: auto;
  }

  .issued-status {
    padding: 5px;
    color: #fff;
    text-transform: capitalize;
    border-radius: 2px;
    background-color: #1ec4b4;
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.17;
    letter-spacing: normal;
    margin: auto;
  }
}

// responsive
@media (max-width: 760px) {
  .left-column {
    border: none;
    padding: 10px;

    .key,
    .value {
      font-size: 14px;
    }
  }

  .right-column {
    padding: 20px 10px 10px 10px;

    p {
      font-size: 14px;
    }
  }

  .multiple-entry-form {
    hr {
      display: block;
    }

    > h5 {
      font-size: 16px;
    }
  }

  .bottom-row {
    .btn {
      font-size: 12px;
    }
  }
}

.chat__btn {
  width: 300px;
  padding: 5px 10px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  align-content: center;
  border: solid 1px #5099de;
  background-color: #ffffff;
  margin-bottom: 20px;
  cursor: pointer;

  > .chat__btn--image {
    width: 30px;
    height: 30px;
  }

  > .chat__btn--text {
    width: calc(100% - 40px);
    font-size: 13px;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.56;
    letter-spacing: normal;
    text-align: center;
    color: #5099de;
  }
}

.chat__container {
  width: 500px;
  padding: 10px;
  overflow: hidden;
  background-color: #ffffff;
  margin-bottom: 20px;

  > textarea {
    width: 100%;
    height: 100px;
    padding: 10px;
    overflow: hidden;
    border: solid 1px #5099de;
    background-color: #ffffff;
    outline: 0;
    font-size: 12px;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.56;
    letter-spacing: normal;
    resize: none;
  }

  > div {
    width: 200px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    align-content: center;
    margin: auto;

    > .chat__container--send {
      width: 45%;
      height: 40px;
      background: #5099de;
      border: 1px solid #5099de;
      color: #fff;
      font-size: 13px;
      font-weight: 200;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.56;
      letter-spacing: normal;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      align-content: center;
      cursor: pointer;
    }

    > .chat__container--cancel {
      width: 45%;
      height: 40px;
      background: #fff;
      border: 1px solid #5099de;
      color: #000;
      font-size: 13px;
      font-weight: 200;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.56;
      letter-spacing: normal;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
      align-content: center;
      cursor: pointer;
    }
  }
}

.page__err {
  font-size: 12px;
  font-style: italic;
  color: red;
}
</style>